import { GeolocationService, GoogleGeocodingService } from '@sweatpals/react-ui-kit';
import { InterestService } from './interestService';
import { ColorGeneratorService } from './color-generator-service';
import { EventsService } from './eventsService';
import { httpClient } from '../data-services';
import { UserService } from './userService';
import { PaymentService } from './paymentService';
import { StripeService } from './stripeService';
import { AuthService } from './authService';
import { PastEventsService } from './pastEventsService';
import { DropdownsValuesService } from './dropdowns-values.service';
import { MembershipsService } from './membership.service';
import { GooglePlacesAutocompleteService } from './google-places-autocomplete.service';
import { CommunityProfilesService } from './community-profiles.service';
import { EventClassesService } from './eventClassesService';
import { EventTicketsReservationService } from './eventTicketsReservations.service';
import { PostsService } from './posts.service';
import { LeaderboardService } from './leaderboard.service';
import { ChallengeService } from './challenge.service';
import { SystemSettingsService } from './systemSettings.service';

export const googleGeocodingService = new GoogleGeocodingService();
export const googlePlacesAutocompleteService = new GooglePlacesAutocompleteService();
export const geolocationService = new GeolocationService(httpClient);

export const authService = new AuthService(httpClient);
export const usersService = new UserService(httpClient);
export const interestService = new InterestService(httpClient);
export const colorGeneratorService = new ColorGeneratorService();
export const eventsService = new EventsService(httpClient);
export const pastEventsService = new PastEventsService(httpClient);
export const paymentService = new PaymentService(httpClient);
export const stripeService = new StripeService();
export const dropdownsValuesService = new DropdownsValuesService(httpClient);
export const membershipsService = new MembershipsService(httpClient);
export const communityProfilesService = new CommunityProfilesService(httpClient);
export const eventClassesService = new EventClassesService(httpClient);
export const eventTicketsReservationService = new EventTicketsReservationService(httpClient);
export const postsService = new PostsService(httpClient);
export const leaderboardService = new LeaderboardService(httpClient);
export const challengeService = new ChallengeService(httpClient);
export const systemSettingsService = new SystemSettingsService(httpClient);